import React from 'react'
import cx from 'classnames'

import { Loader } from 'components/_new/ui'

import s from './ContentLoader.scss'


export type ContentLoaderProps = {
  className?: string
  fullHeight?: boolean
}

const ContentLoader: React.FunctionComponent<ContentLoaderProps> = ({ className, fullHeight }) => (
  <div className={cx(s.loaderContainer, className, { [s.fullHeight]: fullHeight })}>
    <Loader />
  </div>
)


export default ContentLoader
